import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type Props = {
  companyId?: string;
};

export function useDeleteUser({ companyId }: Props) {
  const queryClient = useQueryClient();
  const resource = companyId ? `admin/companies/${companyId}/users` : 'users';

  const { mutateAsync, error, isLoading, reset } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`${resource}/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  const deleteUser = async (id: string) => {
    await mutateAsync(id);
  };

  return {
    deleteUser,
    error,
    isLoading,
    reset,
  };
}
